import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

const ReportPage = () => {
  const [data, setData] = useState([
    {
      testName: "com.productmadness.automation.tests.smoke.game.SpinTest",
      failedWith:
        "Game screen is not opened expected [true] but found [false]",
      count: 63,
      notes: "This is some config issue",
    },
    {
      testName:
        "com.productmadness.automation.tests.smoke.lobby.EarlyAccessTargetCrmTest",
      failedWith:
        "Game 'Buffalo Clone' is not present in beginning of Lobby expected [true] but found [false]",
      count: 3,
      notes: "Locator changed",
    },
  ]);

  const [editingRows, setEditingRows] = useState(null);

  const onRowEditComplete = (e) => {
    let updatedData = [...data];
    updatedData[e.index] = e.data;
    setData(updatedData);
  };

  const editTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-pencil"
        className="p-button-text"
        onClick={() => alert(`Editing ${rowData.testName}`)}
      />
    );
  };

  const generateReport = () => {
    alert("Generating/Exporting/Sharing report...");
    console.log("Report data:", data);
  };

  return (
    <div className="p-p-4" style={{ fontFamily: "Arial, sans-serif" }}>
      <h1>Single Report Page for - CC 4.5.11 release</h1>

      <DataTable
        value={data}
        editable
        editMode="row"
        dataKey="testName"
        onRowEditComplete={onRowEditComplete}
        responsiveLayout="scroll"
        header="Test Automation Results"
      >
        <Column field="testName" header="Test Name" style={{ width: "30%" }} />
        <Column
          field="failedWith"
          header="Failed With"
          style={{ width: "30%" }}
        />
        <Column field="count" header="Count" style={{ width: "10%" }} />
        <Column
          field="notes"
          header="Notes"
          editor={(options) => (
            <InputText
              value={options.value}
              onChange={(e) => options.editorCallback(e.target.value)}
            />
          )}
          style={{ width: "20%" }}
        />
        <Column body={editTemplate} header="Edit" style={{ width: "10%" }} />
      </DataTable>
    <br/>
      <Button
        label="Generate/Export/Share"
        icon="pi pi-share-alt"
        className="p-mt-3"
        style={{ width: "200px" }}
        onClick={generateReport}
      />
    </div>
  );
};

export default ReportPage;
